import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export function Modal({ isOpen, onClose, title, children }: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="relative z-[9999]">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/75 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      
      {/* Modal */}
      <div 
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{ minHeight: '100vh' }}
      >
        <div 
          className="w-full max-w-2xl shadow-2xl" style={{ background: '#131313', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '4px' }}
          role="dialog"
          aria-modal="true"
          onClick={e => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-5" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <h3 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '14px', fontWeight: 700, color: '#EEEAD5' }}>
              {title}
            </h3>
            <button
              type="button"
              className="p-1.5 rounded-sm transition-colors"
              style={{ color: '#888874', background: 'transparent', border: 'none', cursor: 'pointer' }}
              onClick={onClose}
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          {/* Content */}
          <div 
            className="p-6 overflow-y-auto"
            style={{ maxHeight: 'calc(100vh - 200px)' }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
} 